<template>
  <div class="h-screen" :class="[`bg-${$route.meta.background}`]">
    <Preloader v-if="isLoading" />
    <div class="contact">
      <div class="contact__arrow">
        <router-link :to="routeName">
          <img class="arrow" src="@/assets/images/icons/right-arrow.svg" />
        </router-link>
      </div>
      <div class="contact__logo">
        <img src="@/assets/images/brand/logo.svg" />
        <h3 class="contact__title">Kontakt</h3>
      </div>
      <div class="contact__content">
        <ContactCard
          :id="'lector'"
          :name="lector"
          :userName="lectorName"
          :email="lectorEmail"
        />
        <div class="contact__separator"></div>
        <ContactCard
          :id="'agency'"
          :name="agency"
          :userName="agencyName"
          :email="agencyEmail"
          :phones="agencyPhones"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Preloader from '@/components/Preloader.vue';
import ContactCard from '@/components/Contact/ContactCard.vue';

export default {
  name: 'Contact',

  data() {
    return {};
  },

  components: {
    Preloader,
    ContactCard,
  },

  computed: {
    ...mapState('students', ['student']),
    ...mapState('layout', ['isLoading']),

    lectorName() {
      const lectorObj = this.student?.group?.lector;
      if (lectorObj) {
        return `${lectorObj.firstName} ${lectorObj.lastName}`;
      }
      return '';
    },
    lectorEmail() {
      const lectorEmail = this.student?.group?.lector?.email;
      if (lectorEmail) return lectorEmail;
      return '';
    },
    agencyName() {
      const agencyName = this.student?.group?.agency?.name;
      if (agencyName) return agencyName;
      return '';
    },
    agencyEmail() {
      const agencyEmail = this.student?.group?.agency?.email;
      if (agencyEmail) return agencyEmail;
      return '';
    },
    agencyPhones() {
      const agencyPhones = this.student?.group?.agency?.phones;
      if (agencyPhones?.length) return agencyPhones;
      return [];
    },
    lector() {
      return this.$t('contact.lector');
    },

    agency() {
      return this.$t('contact.agency');
    },

    routeName() {
      if (
        this.student !== null
        && Object.prototype.hasOwnProperty.call(this.student, 'group')
      ) {
        return {
          name: 'Main.Attendances',
          params: { kidId: this.student.id },
        };
      }
      return { name: 'Auth.Welcome' };
    },
  },

  created() {
    this.$store.commit('layout/startLoading');
  },

  mounted() {
    setTimeout(() => {
      this.$store.commit('layout/finishLoading');
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.contact {
  @apply relative px-4 pb-12 flex flex-col justify-start mx-auto;
  max-width: 900px;
  min-height: 100vh;
  &__logo {
    @apply mt-10 mb-8;
    img {
      @apply block mx-auto mb-10;
    }
  }
  &__title {
    @apply font-bold text-4xl text-center block;
  }
  &__arrow {
    @apply absolute mt-3;
    left: -8px;
    top: 20px;
    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
    img {
      @apply p-6;
    }
    &:hover {
      transform: translateX(-10px);
    }
  }

  &__content {
    @apply px-6 bg-blue-light-main;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      @apply px-8;
    }
  }
  &__separator {
    @apply w-full;
    background: #d9d9d9;
    height: 1px;
  }
}
</style>
